import { AbstractIdbaModel } from "src/app/shared/models/abstract-idba-model";

export class Titulo extends AbstractIdbaModel {

  public override convertToModel(data: any): Titulo {
    return new Titulo(data);
  }

  public override display(self: any): string {
    return self && self.id ? `${self.id} - ${self.nome}` : '';
  }
  public override displayCodigo(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override displayNome(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override filter(value: string, objectList: any[]): any[] {
    const filterValue = value.toLowerCase();
    return objectList.filter(
      (item) =>
        item.nome.trim().toLowerCase().includes(filterValue) ||
        item.id.toString().toLowerCase().includes(filterValue)
    );
  }

  cancelado: boolean;
  codigoFebraban: number;
  dataEmissao: Date;
  dataVencimento: Date;
  diasProtesto: number;
  enviadaBanco: boolean;
  idCliente: number;
  idDocumento: number;
  idDuplicata: number;
  idLocal: number;
  idPortador: number;
  idTitulo: number;
  instrucao: string;
  instrucaoProtesto: string;
  liquidado: boolean;
  nomeEspecie: string;
  nomePessoa: string;
  nossoNumero: number;
  numDocumento: number;
  parcela: number;
  percJurosDiasAtraso: number;
  valorAbatimento: number;
  valorDesconto: number;
  valorJuros: number;
  valorMulta: number;
  valorSaldo: number;
  valorTaxas: number;
  valorTitulo: number;
  dataHoraVencimento: Date;
  indTipoTitulo: number;
  idFornecedor: number;
  idTipoTitulo: number;
  idEspecie: number;
  valorDescontoTitulo: number;
  valorDescontoFinanceiro: number;
  situacao: string;

  codigoPessoa: number;
  dataHoraPagamentoIni: Date;
  dataHoraPagamentoFim: Date;
  tipoTitulo: number;

  titulosSubstituidos: string[];
  divisao: number;
  codigoProduto: number;
  observacaoTitulo: string;
}
